module.exports = __webpack_public_path__ + "img/logo.29c22e95.png";